export default __webpack_public_path__ + "static/media/Switch_disabled.3bb8df3c.jpg";